import { render, staticRenderFns } from "./GeneratedDocuments.vue?vue&type=template&id=3bc74d5d&"
import script from "./GeneratedDocuments.vue?vue&type=script&lang=js&"
export * from "./GeneratedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeneratedDocuments.vue"
export default component.exports